import Button from '../../components/bootstrap/Button'
import Card, { CardActions, CardBody, CardFooter, CardFooterRight, CardHeader, CardLabel, CardSubTitle, CardTitle } from '../../components/bootstrap/Card'
import Page from '../../layout/Page/Page'
import PageWrapper from '../../layout/PageWrapper/PageWrapper'
import React, { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { userAtom } from '../../_atoms/user'
import { companyAtom } from '../../_atoms/company'
import { useTranslation } from 'react-i18next'
import Label from '../../components/bootstrap/forms/Label'
import FormGroup from '../../components/bootstrap/forms/FormGroup'
import Input from '../../components/bootstrap/forms/Input'
import Select from '../../components/bootstrap/forms/Select'
import { Options } from '../../components/bootstrap/Option'
import ReactCreditCardsContainer from '../../components/extras/ReactCreditCardsContainer'
import ReactCreditCards, { Focused } from 'react-credit-cards-2';
import Payment from 'payment';
import { getCardList, getDirectPayTrToken } from '../../_services/paytr'
import { numberFormat } from '../../helpers/formats'
import axios from 'axios'
import Checks from '../../components/bootstrap/forms/Checks'
import Alert, { AlertHeading } from '../../components/bootstrap/Alert'
import dayjs from 'dayjs'
import Modal, { ModalBody } from '../../components/bootstrap/Modal'
import { getOxyTransactions } from '../../_services/companyTransaction'
import CommonTable from '../../components/CommonTable'
import PaginationButtons from '../../components/PaginationButtons'
import { updateUser } from '../../_services/user'
import showNotification from '../../components/extras/showNotification'
import Icon from '../../components/icon/Icon'
// import PaymentDialog from './PaymentDialog'

const Payments = () => {

    const [mode, setMode] = useState(0)
    const [user, setUser] = useAtom(userAtom)
    const [company] = useAtom(companyAtom)
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState(user?.email || '')
    const [identityNumber, setIdentityNumber] = useState('')
    const [address, setAddress] = useState('')
    const [city, setCity] = useState('')
    const [zipCode, setZipCode] = useState('')
    const [phone, setPhone] = useState(user?.phone || '')
    const [ip, setIp] = useState('')
    const [payTrToken, setPayTrToken] = useState('')
    const [months, setMonths] = useState(1)
    const [base, setBase] = useState(0)
    const [merchant_oid, setmerchant_oid] = useState(null)
    const [newPayment, setNewPayment] = useState(false)

    const [cardNumber, setCardNumber] = useState('');
    const [expireMonth, setExpireMonth] = useState('');
    const [expireYear, setExpireYear] = useState('');
    const [cvc, setCvc] = useState('');
    const [cardName, setCardName] = useState('');
    const [store_card, setstore_card] = useState(1)

    const [paytrHtml, setPaytrHtml] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [pastPayments, setPastPayments] = useState([])
    const [count, setCount] = useState(0)
    const [pageSize, setPageSize] = useState(20)
    const [currentPage, setCurrentPage] = useState(1)
    // const [paymentDialogOpen, setPaymentDialogOpen] = useState(false)
    const [selectedCard, setSelectedCard] = useState(null)

    const { utoken } = user
    const { token } = user

    const [cardList, setCardList] = useState([])

    let price = base * months


    useEffect(() => {
        if (company && company._id && company.oxySubscription) {
            const numberOfBranches = company.numberOfBranches || 1
            const calculatedBase = company.oxySubscription.price + (company.oxySubscription.additionalBranchPrice * (numberOfBranches - 1))
            setBase(calculatedBase)
        }
    }, [company])

    useEffect(() => {
        if (company?._id) {
            getOxyTransactions(token, { company: company._id, limit: pageSize, skip: (currentPage - 1) * pageSize })
                .then(res => {
                    if (res?.data?.code === 200) {
                        setPastPayments(res.data.data)
                        setCount(res.data.count)
                    }
                })
        }
    }, [company])

    useEffect(() => {
        if (cardList?.length > 0) {
            setSelectedCard(cardList[0].ctoken)
        }
    }, [cardList])

    useEffect(() => {
        if (user._id) {
            setEmail(user?.email || '')
            setIdentityNumber(user?.identityNumber || '')
            setAddress(user?.address || '')
            setCity(user?.city || '')
            setZipCode(user?.zipCode || "")
            setPhone(user?.phone || '')
        }
    }, [user])

    useEffect(() => {
        if (utoken && utoken.length > 0) {
            getCardList({ utoken })
                .then(res => {
                    if (res?.data?.code === 200) {
                        setCardList(res.data.data)
                    }
                })
        } else {
            setCardList([])
        }
    }, [utoken])

    const handlePaymentResponse = (responseHtml) => {
        setPaytrHtml(responseHtml);
        setShowModal(true);
    };

    useEffect(() => {
        const getUserIp = async () => {
            try {
                const res = await fetch('https://geolocation-db.com/json/');
                const data = await res.json();
                setIp(data.IPv4);
            } catch (err) {
                setIp('');
            }
        };
        getUserIp();
    }, []);

    const handleResetForm = () => {
        setEmail(user?.email || '')
        setIdentityNumber(user?.identityNumber || '')
        setAddress(user?.address || '')
        setCity(user?.city || '')
        setZipCode(user?.zipCode || "")
        setPhone(user?.phone || '')
        setMonths(1)
        setPayTrToken('')
        setPaytrHtml(null)
        setShowModal(false)
        setMode(0)
        setNewPayment(false)
    };

    const handlePayTrToken = async () => {
        // Basic validation örneği
        if (!ip || !email || !user.firstname || !user.familyname || !address || !city) {
            // Burada formik ile daha gelişmiş validasyon entegre edebilirsin
            showNotification(
                <span className='d-flex align-items-center'>
                    <Icon icon='Info' size='lg' className='me-1' />
                    <span>Hata</span>
                </span>,
                "Lütfen bilgileri eksizsiz giriniz.",
            );
            return;
        }

        const data = {
            user_params: {
                user_ip: ip,
                user_name: `${user.firstname} ${user.familyname}`,
                user_address: `${address} ${zipCode} ${city}`,
                user_phone: phone.toString() || "5111111111",
                user_basket: JSON.stringify([["OxyFit Club Aylık Abonelik", (price).toString(), months]]),
                email: email.trim().replace(' ', ''),
                payment_amount: (price).toString(),
                currency: 'TL',
                non_3d: 0,
                identityNumber,
                payment_type: "card",
                installment_count: 0,
                test_mode: 0,
                merchant_ok_url: 'https://oxyfitclub.com/odeme-basarili',
                merchant_fail_url: 'https://oxyfitclub.com/odeme-hata',
            },
            panelUser: user._id,
            company : company._id,
            price,
            months,
        };
        setLoading(true)
        updateUser(token, {
            id: user._id,
            address,
            city,
            zipCode,
            phone,
            identityNumber
        }).then(res => {
            if (res?.data?.code === 200) {
                setUser({ ...user, ...res.data.data })
            }
        })


        try {
            const res = await getDirectPayTrToken(data)
            setLoading(false)
            if (res.data && res.data.code === 200) {
                setPayTrToken(res.data.data)
                setmerchant_oid(res.data.merchantoid)
            }
        } catch (err) {
            setLoading(false)
        }
    }

    const completePayment = async () => {
        const data = {
            merchant_id: "618759",
            paytr_token: payTrToken,
            merchant_oid,
            payment_type: "card",
            installment_count: 0,
            no_installment: 0,
            max_installment: 0,
            lang: "tr",
            test_mode: 0,
            non_3d: 0,
            cc_owner: cardName,
            card_number: cardNumber,
            expiry_month: expireMonth,
            expiry_year: expireYear,
            cvv: cvc,
            user_ip: ip,
            user_name: `${user.firstname} ${user.familyname}`,
            user_address: `${address} ${zipCode} ${city}`,
            user_phone: phone.toString() || "5111111111",
            user_basket: JSON.stringify([["OxyFit Club Aylık Abonelik", (price).toString(), months]]),
            email: email.trim().replace(' ', ''),
            payment_amount: (price).toString(),
            currency: 'TL',
            merchant_ok_url: 'https://oxyfitclub.com/odeme-basarili',
            merchant_fail_url: 'https://oxyfitclub.com/odeme-hata',
            store_card,
        }

        if (user.utoken) {
            data.utoken = user.utoken
        }

        // bu data https://www.paytr.com/odeme adresine post atilacak

        try {
            const res = await axios.post(
                'https://www.paytr.com/odeme',
                new URLSearchParams(data),
                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
            );

            // Başarılı cevap:
            if (typeof res.data === 'string') {
                handlePaymentResponse(res.data)
            } else {
                showNotification(
                    <span className='d-flex align-items-center'>
                        <Icon icon='Info' size='lg' className='me-1' />
                        <span>Ödeme sırasında hata:</span>
                    </span>,
                    res.data,
                );
            }
            // Devamında yönlendirme veya kullanıcıya bilgi gösterimi yapılabilir.
        } catch (err) {

            showNotification(
                <span className='d-flex align-items-center'>
                    <Icon icon='Info' size='lg' className='me-1' />
                    <span>Ödeme sırasında hata:</span>
                </span>,
                err.response?.data || err.message,
            );
        }
    }


    const completeRecurrentPayment = async () => {
        const data = {
            merchant_id: "618759",
            paytr_token: payTrToken,
            merchant_oid,
            payment_type: "card",
            installment_count: 0,
            no_installment: 0,
            max_installment: 0,
            lang: "tr",
            test_mode: 0,
            non_3d: 0,
            cc_owner: cardName,
            card_number: cardNumber,
            expiry_month: expireMonth,
            expiry_year: expireYear,
            cvv: cvc,
            user_ip: ip,
            user_name: `${user.firstname} ${user.familyname}`,
            user_address: `${address} ${zipCode} ${city}`,
            user_phone: phone.toString() || "5111111111",
            user_basket: JSON.stringify([["OxyFit Club Aylık Abonelik", (price).toString(), months]]),
            email: email.trim().replace(' ', ''),
            payment_amount: (price).toString(),
            currency: 'TL',
            merchant_ok_url: 'https://oxyfitclub.com/odeme-basarili',
            merchant_fail_url: 'https://oxyfitclub.com/odeme-hata',
            store_card,
            ctoken: selectedCard
        }

        if (user.utoken) {
            data.utoken = user.utoken
        }

        // bu data https://www.paytr.com/odeme adresine post atilacak

        try {
            const res = await axios.post(
                'https://www.paytr.com/odeme',
                new URLSearchParams(data),
                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
            );

            // Başarılı cevap:
            if (typeof res.data === 'string') {
                handlePaymentResponse(res.data)
            } else {
                console.log(res.data)
            }
            // Devamında yönlendirme veya kullanıcıya bilgi gösterimi yapılabilir.
        } catch (err) {
            console.error('Ödeme sırasında hata:', err.response?.data || err.message);
            // Hata mesajı gösterilebilir.
        }
    }

    const columns = [
        { value: "user", label: "Ödeyen", width: "150px" },
        { value: "amount", label: "Tutar", width: "150px" },
        { value: "description", label: "Açıklama" },
    ]

    const rows = () => pastPayments.map((payment, index) => ({
        id: index,
        user: <div>
            <strong>{payment?.panelUser?.firstname} {payment?.panelUser?.familyname}</strong>
            <div>{payment.created ? dayjs(payment.created).format("DD.MM.YYYY, HH:mm") : "-"}</div>
        </div>,
        description: payment.description || "Açıklama yok",
        amount: <div>
            <strong>{
                `${numberFormat(payment.amount)} ${payment.currency || "TL"}`
            }</strong>
            <div>
                {payment.status === "success"
                    ? <span className="badge bg-success">Başarılı</span>
                    : <span className="badge bg-danger">Başarısız</span>}
            </div>
        </div>,
    }))

    if (mode === 1) {
        return (
            <PageWrapper>
                <Page container="fluid">
                    <div className='h-100'>
                        <Card stretch>
                            <CardHeader>
                                <CardLabel icon='CreditCard' iconColor="success">
                                    <CardTitle>Ödeme Ekranı - {numberFormat(price)}₺</CardTitle>
                                    <CardSubTitle>{company?.oxySubscription?.name} aboneliğiniz kapsamında aylık {numberFormat(company?.oxySubscription?.price)}₺ ödeme yapıyorsunuz.
                                        {company?.numberOfBranches > 1 &&
                                            ` Ayrıca eklediğiniz ${company.numberOfBranches - 1} şube için, şube başına ${company?.oxySubscription.additionalBranchPrice}₺ ödeme yapıyorsunuz.`
                                        }

                                    </CardSubTitle>
                                </CardLabel>
                                <CardActions>
                                    {payTrToken
                                        ? <Button onClick={() => setPayTrToken(null)} isLight icon='Close' color='danger'>Kapat</Button>
                                        : <>
                                            <Button onClick={() => {
                                                setNewPayment(false)
                                                setSelectedCard(null)
                                                setMode(0)
                                            }} isLight icon='Close' color='danger'>Kapat</Button>
                                            <Button onClick={handlePayTrToken} isLight icon='Save' color='success'>Ödemeyi Başlat</Button>
                                        </>
                                    }

                                </CardActions>
                            </CardHeader>
                            <CardBody isScrollable>
                                {payTrToken ? (
                                    (cardList?.length > 0 && !newPayment)
                                        ? <div className='row g-4 justify-content-center'>
                                            <div className="col-sm-12 col-md-6">
                                                <Label>Kart Seçin</Label>
                                                <div className="mb-3">
                                                    {cardList.map(card => (
                                                        <label
                                                            key={card._id}
                                                            className={`card-select w-100 d-flex align-items-center p-2 mb-2 ${selectedCard === card.ctoken ? "selected" : ""}`}
                                                            style={{ border: selectedCard === card.ctoken ? "2px solid #27ae60" : "1px solid #ddd", borderRadius: 8, cursor: "pointer" }}
                                                        >
                                                            <input
                                                                type="radio"
                                                                name="card"
                                                                checked={selectedCard === card.ctoken}
                                                                onChange={() => setSelectedCard(card.ctoken)}
                                                                style={{ marginRight: 12, accentColor: "#27ae60" }}
                                                            />
                                                            <span style={{ fontWeight: 500 }}>
                                                                **** **** **** {card.last_4} - {card.c_bank} ({card.c_brand})
                                                            </span>
                                                            <span className="ms-2 text-muted" style={{ fontSize: 13 }}>
                                                                {card.c_name}
                                                            </span>
                                                        </label>
                                                    ))}

                                                </div>
                                                <div>
                                                    <Button icon='Payment' color='success' onClick={completeRecurrentPayment}>Seçili Kartla Öde</Button>
                                                    <Button
                                                        icon='Plus'
                                                        color='info'
                                                        className="ms-2"
                                                        isLight
                                                        onClick={() => setNewPayment(true)}
                                                    >
                                                        Yeni Kart ile Öde
                                                    </Button>
                                                </div>
                                            </div>

                                        </div>
                                        : <div className="row g-4">
                                            <div className="row g-4 col-sm-12 col-md-4">
                                                <ReactCreditCardsContainer
                                                    issuer={Payment.fns.cardType(cardNumber)}>
                                                    <ReactCreditCards
                                                        cvc={cvc}
                                                        expiry={expireMonth + expireYear}
                                                        name={cardName}
                                                        number={cardNumber.replace(/\d(?!(\d*)$)/g, '*')}
                                                        preview
                                                        issuer={Payment.fns.cardType(cardNumber)}
                                                    />
                                                </ReactCreditCardsContainer>
                                            </div>
                                            <div className="row g-4 col-sm-12 col-md-8">
                                                <div className="col-6">
                                                    <FormGroup id="cardName" isFloating label="Kart Üzerindeki İsim">
                                                        <Input
                                                            id="cardName"
                                                            value={cardName}
                                                            onChange={e => setCardName(e.target.value)}
                                                            placeholder="AD SOYAD"
                                                            autoComplete="cc-name"
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-6">
                                                    <FormGroup id="cardNumber" isFloating label="Kart Numarası">
                                                        <Input
                                                            id="cardNumber"
                                                            value={cardNumber}
                                                            type="text" // <-- DÜZELTİLDİ!
                                                            onChange={e => setCardNumber(e.target.value.replace(/\D/g, ""))}
                                                            maxLength={19}
                                                            placeholder="1234 5678 9012 3456"
                                                            autoComplete="cc-number"
                                                        />

                                                    </FormGroup>
                                                </div>
                                                <div className="col-3">
                                                    <FormGroup id="expireMonth" isFloating label="Ay (MM)">
                                                        <Input
                                                            id="expireMonth"
                                                            value={expireMonth}
                                                            onChange={e => setExpireMonth(e.target.value.replace(/\D/g, ""))}
                                                            maxLength={2}
                                                            placeholder="12"
                                                            autoComplete="cc-exp-month"
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-3">
                                                    <FormGroup id="expireYear" isFloating label="Yıl (YY)">
                                                        <Input
                                                            id="expireYear"
                                                            value={expireYear}
                                                            onChange={e => setExpireYear(e.target.value.replace(/\D/g, ""))}
                                                            maxLength={2}
                                                            placeholder="29"
                                                            autoComplete="cc-exp-year"
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-6">
                                                    <FormGroup id="cvc" isFloating label="CVC">
                                                        <Input
                                                            id="cvc"
                                                            value={cvc}
                                                            onChange={e => setCvc(e.target.value.replace(/\D/g, ""))}
                                                            maxLength={4}
                                                            placeholder="123"
                                                            autoComplete="cc-csc"
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-12">
                                                    <Checks
                                                        checked={store_card === 1}
                                                        onChange={() => store_card === 1 ? setstore_card(0) : setstore_card(1)}
                                                        label="Kartınız saklansın mı?"
                                                    />
                                                </div>
                                                <Alert
                                                    icon='Info'
                                                    isLight
                                                    color='primary'
                                                    borderWidth={0}
                                                    className='shadow-3d-primary'
                                                >
                                                    <AlertHeading tag='h2' className='h4'>
                                                        Bilgilendirme!
                                                    </AlertHeading>
                                                    <span>Kart saklama işleminde çözüm ortağımız PAYTR olup, kart bilgileriniz yalnızca iş ortağımız PAYTR veritabanında güvenle tutulmaktadır. Firmamızın kart bilgilerinize erişimi yoktur.</span>
                                                </Alert>

                                                <div className='col-12'>
                                                    <Button icon='Payment' color='success' onClick={completePayment}>Ödemeyi Tamamla</Button>
                                                </div>
                                            </div>
                                        </div>
                                ) : (
                                    <>
                                        <Label>{"Ödeme için gerekli bilgileri doldurun."}</Label>
                                        <Alert
                                            icon='Info'
                                            isLight
                                            color='primary'
                                            borderWidth={0}
                                            className='shadow-3d-primary'
                                        >
                                            <AlertHeading tag='h2' className='h4'>
                                                Bilgilendirme!
                                            </AlertHeading>
                                            <span>Mevcut panel erişiminiz {dayjs(company.validUntil).format("DD MMMM YYYY")} tarihine kadardır. Bu tarihe kadar ödeme yapmamanız durumunda panel erişiminiz kısıtlanabilir.</span>
                                        </Alert>
                                        <div className="row g-4">
                                            <div className="col-12 col-md-6">
                                                <FormGroup id="price" isFloating label={"Tutar"}>
                                                    <Input
                                                        id="price"
                                                        type="number"
                                                        value={price}
                                                        disabled
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <FormGroup id="months" isFloating label={"Kaç Aylık"}>
                                                    <Select
                                                        value={months}
                                                        onChange={e => setMonths(Number(e.target.value) || 1)}
                                                    >
                                                        <Options list={[
                                                            { value: 1, label: 1 },
                                                            { value: 2, label: 2 },
                                                            { value: 3, label: 3 },
                                                            { value: 4, label: 4 },
                                                            { value: 5, label: 5 },
                                                            { value: 6, label: 6 },
                                                            { value: 8, label: 8 },
                                                            { value: 12, label: 12 },
                                                        ]} />
                                                    </Select>
                                                </FormGroup>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <FormGroup id="email" isFloating label={t("common.email")}>
                                                    <Input
                                                        id="email"
                                                        type="email"
                                                        value={email}
                                                        onChange={e => setEmail(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <FormGroup id="identityNumber" isFloating label={"TC Kimlik No"}>
                                                    <Input
                                                        id="identityNumber"
                                                        value={identityNumber}
                                                        onChange={e => setIdentityNumber(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <FormGroup id="phone" isFloating label={"Telefon"}>
                                                    <Input
                                                        id="phone"
                                                        value={phone}
                                                        onChange={e => setPhone(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <FormGroup id="zipCode" isFloating label={"Posta Kodu"}>
                                                    <Input
                                                        id="zipCode"
                                                        value={zipCode}
                                                        onChange={e => setZipCode(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-12">
                                                <FormGroup id="address" isFloating label={t("common.address")}>
                                                    <Input
                                                        id="address"
                                                        value={address}
                                                        onChange={e => setAddress(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-12">
                                                <FormGroup id="city" isFloating label={t("common.city")}>
                                                    <Input
                                                        id="city"
                                                        value={city}
                                                        onChange={e => setCity(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </CardBody>
                        </Card>
                    </div>
                </Page>
                <Modal isOpen={showModal} setIsOpen={() => null} size="xl">
                    <CardHeader>
                        <CardLabel icon='Security' iconColor="info">
                            <CardTitle>Güvenlik Ekranı</CardTitle>
                            <CardSubTitle>Lütfen tarafınıza iletilen doğrulama kodu ile işlem yapınız.</CardSubTitle>
                        </CardLabel>
                        <CardActions>
                            <Button color='danger' icon='Close' onClick={handleResetForm}>Kapat</Button>
                        </CardActions>
                    </CardHeader>
                    <ModalBody>
                        {paytrHtml && (
                            <iframe
                                title="PayTR 3D Secure"
                                srcDoc={paytrHtml}
                                style={{ width: "100%", height: "600px", border: "none" }}
                                sandbox="allow-scripts allow-same-origin allow-forms"
                            />
                        )}
                    </ModalBody>
                </Modal>
            </PageWrapper>
        )
    }

    return (
        <PageWrapper>
            <Page container="fluid">
                <div className='row h-100'>
                    <div className='col-sm-12 col-md-3'>
                        <Card stretch>
                            <CardHeader>
                                <CardLabel icon='CreditCard' iconColor="success">
                                    <CardTitle>Kayıtlı Kartlarım</CardTitle>
                                    <CardSubTitle>Kart kaydederek ödemelerinizi otomatik olarak yapabilirsiniz.</CardSubTitle>
                                </CardLabel>
                            </CardHeader>

                            <CardBody isScrollable>
                                <div className='row g-4'>
                                    {cardList.map((card, idx) => (
                                        <div key={card.ctoken || idx} className="col-sm-12">
                                            <ReactCreditCardsContainer issuer={card.schema}>
                                                <ReactCreditCards
                                                    number={`**** **** **** ${card.last_4}`}
                                                    name={card.c_name}
                                                    expiry={`${card.month.padStart(2, '0')}${card.year}`}
                                                    cvc={card.require_cvv === "1" ? "•••" : ""}
                                                    issuer={card.schema}
                                                    preview
                                                />
                                            </ReactCreditCardsContainer>
                                            <div className="mt-2 ms-2">
                                                <div><strong>Banka:</strong> {card.c_bank} ({card.c_brand})</div>
                                                <div><strong>Kart Tipi:</strong> {card.c_type === "credit" ? "Kredi Kartı" : "Banka Kartı"}</div>
                                                <div><strong>İlk Hane:</strong> {card.initial}</div>
                                                {/* Diğer bilgileri de ekleyebilirsin */}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                    <div className='col-sm-12 col-md-9'>
                        <Card stretch>
                            <CardHeader>
                                <CardLabel icon='Money' iconColor="success">
                                    <CardTitle>Ödemelerim</CardTitle>
                                    <CardSubTitle>Kayıtlı kartlarınız varsa ödemeleriniz otomatik olarak yapılacaktır.</CardSubTitle>
                                </CardLabel>
                                <CardActions>
                                    {base > 0 &&
                                        <Button icon='Add' color='success' onClick={() => setMode(1)} >Ödeme Yap</Button>
                                        // <Button icon='Add' color='success' onClick={() => setPaymentDialogOpen(true)} >Ödeme Yap</Button>
                                    }
                                </CardActions>
                            </CardHeader>
                            <CardBody isScrollable>
                                <CommonTable columns={columns} rows={rows()} />
                            </CardBody>
                            <CardFooter>
                                <CardFooterRight>
                                    <PaginationButtons
                                        count={count}
                                        label='items'
                                        setCurrentPage={setCurrentPage}
                                        currentPage={currentPage}
                                        perPage={pageSize}
                                        setPerPage={setPageSize}
                                    />
                                </CardFooterRight>
                            </CardFooter>
                        </Card>
                    </div>
                </div>
            </Page>
            {/* <PaymentDialog open={paymentDialogOpen} toggle={() => setPaymentDialogOpen(!paymentDialogOpen)} base={base} /> */}
        </PageWrapper>
    )
}

export default Payments